exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-button{\r\n    margin-top: 28px;\r\n    margin-left: 5px;\r\n    min-width: 100px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main